export default {
  name: 'login',
  path: '/?referer',
  i18n: ['auth/login', 'app'],
  loadComponent: () => import('./index')
};
